import React from 'react';
import classes from './NavBack.module.css'

function NavBack(props) {
    return (
        <div className={classes.navBack}>
            <a href={props.url} className={classes.customLink}>
                <div className={"d-flex"}>
                    <div className={"d-flex"}>
                        <i
                            className={[
                                classes.arrow,
                                classes.left,
                                classes.customMargin,
                            ].join(" ")}
                        ></i>
                    </div>
                    <span className={classes.textBack}>{props.children}</span>
                </div>
            </a>
        </div>
    );
}

export default NavBack;